var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM19 25C18.4477 25 18 24.5523 18 24V10C18 9.44771 18.4477 9 19 9H20.64C21.1923 9 21.64 9.44772 21.64 10V24C21.64 24.5523 21.1923 25 20.64 25H19ZM19 31.64C18.4477 31.64 18 31.1923 18 30.64V29C18 28.4477 18.4477 28 19 28H20.64C21.1923 28 21.64 28.4477 21.64 29V30.64C21.64 31.1923 21.1923 31.64 20.64 31.64H19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon_Error.ecab86fd5b5b2ecf7b48018be5e6150c.svg";
export { ForwardRef as ReactComponent };